import { render } from "./LabelForm.vue?vue&type=template&id=9730449a&ts=true"
import script from "./LabelForm.vue?vue&type=script&lang=ts"
export * from "./LabelForm.vue?vue&type=script&lang=ts"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/inputs/form/LabelForm.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9730449a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9730449a', __exports__)) {
    api.reload('9730449a', __exports__)
  }
  
  module.hot.accept("./LabelForm.vue?vue&type=template&id=9730449a&ts=true", () => {
    api.rerender('9730449a', render)
  })

}


export default __exports__